// import logo from './logo.svg';
import './App.css';

import NavBar  from './components/navbar';
// import ImgSlider from './components/hero_section';
import About from './components/about'
import Footer from './components/footer';
import HomePage from './components/homepage';

import {

  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Team from './components/teams';
import ContactUs from './components/contact_us';
import CLang from './components/programs/c';
import Works from './components/works';
import CppLang from './components/programs/cpp';
import Java from './components/programs/java';
import Python from './components/programs/python';
import Notification from './components/notification';
import ApplicationForm from './components/ApplicationForm';


function App() {

  return (
   <>
   <Router>
    
    <Notification />
   <NavBar title = "UnlockCode"/>
   
   {/* <About /> */}
   {/* <Team /> */}
    <Routes>
          <Route path="/about" element={<About/>} />
          <Route path='/teams' element={<Team/>} />
          <Route path='/contact' element={<ContactUs />} />
          <Route path='/cprograms' element={<CLang />} />
          <Route path='/c++programs' element={<CppLang />} />
          <Route path='/java_programs' element={<Java />} />
          <Route path='/python_programs' element={<Python />} />
          <Route path='/codes' element={<Works />} />
          <Route path='/ApplicationForm' element={<ApplicationForm />} />
          {/* <Route path='/query' element={<Search />} /> */}
          <Route path='/' element={<HomePage />} />
            
      </Routes>
    <Footer/>
    </Router>
   </>
   
  );
}

export default App;
